export default __webpack_public_path__ + "static/media/video.fcfd1cbc.png";